// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1pbUp","range":"MonthRangeSwitch_range__1lFUs","disabled":"MonthRangeSwitch_disabled__15Bq7"};